export default __webpack_public_path__ + "static/media/logo-kubasio.0d3d1b36.png";